import { render, staticRenderFns } from "./ExerciseTags.vue?vue&type=template&id=46d54dd3&"
import script from "./ExerciseTags.vue?vue&type=script&lang=js&"
export * from "./ExerciseTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports